export class Marketplaces {
  static DFW = 'DFW';
}

export class LaunchDates {
  static DFW = '2019-03-06T00:00:00.000000-08:00';
}
